import { getSlideWidthAndHeight, getAnimTypeByPlayMode, getAnimDuration, getTnRotate } from '../utils';
import {
    ENTRY_REVOLVE_INIT_Y_RATE,
    PLAY_MODE,
} from '@src/js/js-keyframe-animation/style-converter/constants';
import { presetClassTypes } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';
import { AnimType } from '@tencent/slide-sdk-model';

export const xTavlst = [
    {
        tm: '0',
        val: {
            strValue: { strValue: '#ppt_x' },
        },
    },
    {
        tm: '5000',
        val: {
            strValue: { strValue: '#ppt_x+0.0242' },
        },
    },
    {
        tm: '10000',
        val: {
            strValue: { strValue: '#ppt_x+0.0479' },
        },
    },
    {
        tm: '15000',
        val: {
            strValue: { strValue: '#ppt_x+0.0704' },
        },
    },
    {
        tm: '20000',
        val: {
            strValue: { strValue: '#ppt_x+0.0911' },
        },
    },
    {
        tm: '25000',
        val: {
            strValue: { strValue: '#ppt_x+0.1096' },
        },
    },
    {
        tm: '30000',
        val: {
            strValue: { strValue: '#ppt_x+0.1254' },
        },
    },
    {
        tm: '35000',
        val: {
            strValue: { strValue: '#ppt_x+0.1381' },
        },
    },
    {
        tm: '40000',
        val: {
            strValue: { strValue: '#ppt_x+0.1474' },
        },
    },
    {
        tm: '45000',
        val: {
            strValue: { strValue: '#ppt_x+0.1531' },
        },
    },
    {
        tm: '50000',
        val: {
            strValue: { strValue: '#ppt_x+0.1550' },
        },
    },
    {
        tm: '55000',
        val: {
            strValue: { strValue: '#ppt_x+0.1531' },
        },
    },
    {
        tm: '60000',
        val: {
            strValue: { strValue: '#ppt_x+0.1474' },
        },
    },
    {
        tm: '65000',
        val: {
            strValue: { strValue: '#ppt_x+0.1381' },
        },
    },
    {
        tm: '70000',
        val: {
            strValue: { strValue: '#ppt_x+0.1254' },
        },
    },
    {
        tm: '75000',
        val: {
            strValue: { strValue: '#ppt_x+0.1096' },
        },
    },
    {
        tm: '80000',
        val: {
            strValue: { strValue: '#ppt_x+0.0911' },
        },
    },
    {
        tm: '85000',
        val: {
            strValue: { strValue: '#ppt_x+0.0704' },
        },
    },
    {
        tm: '90000',
        val: {
            strValue: { strValue: '#ppt_x+0.0479' },
        },
    },
    {
        tm: '95000',
        val: {
            strValue: { strValue: '#ppt_x+0.0242' },
        },
    },
    {
        tm: '100000',
        val: {
            strValue: { strValue: '#ppt_x' },
        },
    },
];

export const yTavlst = [
    {
        tm: '0',
        val: {
            strValue: { strValue: '#ppt_y+0.31' },
        },
    },
    {
        tm: '5000',
        val: {
            strValue: { strValue: '#ppt_y+0.308' },
        },
    },
    {
        tm: '10000',
        val: {
            strValue: { strValue: '#ppt_y+0.3024' },
        },
    },
    {
        tm: '15000',
        val: {
            strValue: { strValue: '#ppt_y+0.2931' },
        },
    },
    {
        tm: '20000',
        val: {
            strValue: { strValue: '#ppt_y+0.2804' },
        },
    },
    {
        tm: '25000',
        val: {
            strValue: { strValue: '#ppt_y+0.2646' },
        },
    },
    {
        tm: '30000',
        val: {
            strValue: { strValue: '#ppt_y+0.2461' },
        },
    },
    {
        tm: '35000',
        val: {
            strValue: { strValue: '#ppt_y+0.2253' },
        },
    },
    {
        tm: '40000',
        val: {
            strValue: { strValue: '#ppt_y+0.2029' },
        },
    },
    {
        tm: '45000',
        val: {
            strValue: { strValue: '#ppt_y+0.1792' },
        },
    },
    {
        tm: '50000',
        val: {
            strValue: { strValue: '#ppt_y+0.155' },
        },
    },
    {
        tm: '55000',
        val: {
            strValue: { strValue: '#ppt_y+0.1307' },
        },
    },
    {
        tm: '60000',
        val: {
            strValue: { strValue: '#ppt_y+0.1071' },
        },
    },
    {
        tm: '65000',
        val: {
            strValue: { strValue: '#ppt_y+0.0846' },
        },
    },
    {
        tm: '70000',
        val: {
            strValue: { strValue: '#ppt_y+0.0639' },
        },
    },
    {
        tm: '75000',
        val: {
            strValue: { strValue: '#ppt_y+0.0454' },
        },
    },
    {
        tm: '80000',
        val: {
            strValue: { strValue: '#ppt_y+0.0296' },
        },
    },
    {
        tm: '85000',
        val: {
            strValue: { strValue: '#ppt_y+0.0169' },
        },
    },
    {
        tm: '90000',
        val: {
            strValue: { strValue: '#ppt_y+0.0076' },
        },
    },
    {
        tm: '95000',
        val: {
            strValue: { strValue: '#ppt_y+0.0019' },
        },
    },
    {
        tm: '100000',
        val: {
            strValue: { strValue: '#ppt_y' },
        },
    },
];

export const getOpacityValue = (duration, playMode, animClass, xFrame) => {
    const OPACITY_TIME_RATE = 0.1;
    const showDur = OPACITY_TIME_RATE * duration;
    const delayDur = (1 - OPACITY_TIME_RATE) * duration;
    if (animClass === presetClassTypes.ENTR) {
        return [{ value: 1, duration: showDur }];
    }
    if (playMode === PLAY_MODE.edit) {
        return [{ value: 0, duration: showDur, delay: delayDur }];
    }
    //  对播放态-退场-中心旋转动画的特殊处理，该类型下透明动画需要延迟0.9 * duration执行
    return [
        { value: 1, duration: delayDur },
        { value: 0, duration: showDur },
    ];
};

const getOpacityValueForCanvas = (duration, playMode, animClass, xFrame) => {
    const OPACITY_TIME_RATE = 0.1;
    const showDur = OPACITY_TIME_RATE * duration;
    const delayDur = (1 - OPACITY_TIME_RATE) * duration;
    const extraFrameLength = xFrame.length;
    const extraFrameArr: any = [];
    for (let i = 0; i < extraFrameLength; i++) {
        extraFrameArr.push({ value: 1, duration: showDur });
    }
    if (animClass === presetClassTypes.ENTR) {
        return [{ value: 1, duration: showDur }, ...extraFrameArr];
    }
    if (playMode === PLAY_MODE.edit) {
        return [...extraFrameArr, { value: 0, duration: showDur, delay: delayDur }];
    }
    //  对播放态-退场-中心旋转动画的特殊处理，该类型下透明动画需要延迟0.9 * duration执行
    return [
        { value: 1, duration: delayDur },
        ...extraFrameArr,
        { value: 0, duration: showDur },
    ];
};

export const getTranslateKeyFrame = (tavlst, attrs) => {
    const { attrName, attrValue, duration } = attrs;
    const keyFrameArr = tavlst.map((eachTav) => {
        const { val: { strValue: { strValue = '' } = {} } = {} } = eachTav;
        const splitArr = strValue.split(`${attrName}`);
        const spiltArrLength = splitArr.length;
        const EXPECT_LEN = 2;
        const DEFAULT_RATE = 0;
        let rate = DEFAULT_RATE;
        if (spiltArrLength === EXPECT_LEN) {
            rate = Number(splitArr[spiltArrLength - 1]);
        }
        const MOVE_TIME_RATE = 0.6;
        const EACH_MOVE_RATE = 0.05;
        const eachFrameDur = EACH_MOVE_RATE * MOVE_TIME_RATE * duration;
        return {
            value: rate * attrValue,
            duration: eachFrameDur,
            easing: 'linear',
        };
    });
    return keyFrameArr;
};

export const getTranslateX = (xFrame, animClass, translateXValue) => {
    const xTemp = xFrame.slice(1);
    if (animClass === presetClassTypes.ENTR) {
        return [translateXValue, ...xTemp];
    }
    return [...xTemp, translateXValue];
};

const getTranslateXForCanvas = (xFrame, animClass, translateXValue) => {
    const xTemp = xFrame.slice(1);
    if (animClass === presetClassTypes.ENTR) {
        return [...translateXValue, ...xTemp];
    }
    return [...xTemp, ...translateXValue];
};

export const getTranslateY = (yFrame, animClass, translateYValue, playMode) => {
    if (animClass === presetClassTypes.ENTR) {
        const yTemp = yFrame.slice(1);
        return [translateYValue, ...yTemp];
    }
    const yTemp = yFrame.reverse().slice(1);
    if (playMode === PLAY_MODE.edit) {
        return [...yTemp, translateYValue];
    }
    // 对播放态-退场-中心旋转动画的特殊处理
    // 由于该类型透90%透明动画的关键帧中translateY为0，会导致从60%关键帧到90%关键帧时动画回到元素原位置
    // 因此需要在90%关键帧处重新设置translateY的值，以便保证动画的正确效果
    const { duration: lastStillDur } = translateYValue;
    const NINETY_KEYFRAME_RATE = 0.75;
    return [
        ...yTemp,
        {
            ...translateYValue,
            duration: NINETY_KEYFRAME_RATE * lastStillDur,
        },
        {
            ...translateYValue,
            duration: (1 - NINETY_KEYFRAME_RATE) * lastStillDur,
        },
    ];
};

const getTranslateYForCanvas = (yFrame, animClass, translateYValue, playMode) => {
    if (animClass === presetClassTypes.ENTR) {
        const yTemp = yFrame.slice(1);
        return [...translateYValue, ...yTemp];
    }
    const yTemp = yFrame.reverse().slice(1);
    if (playMode === PLAY_MODE.edit) {
        return [...yTemp, ...translateYValue];
    }
    // 对播放态-退场-中心旋转动画的特殊处理
    // 由于该类型透90%透明动画的关键帧中translateY为0，会导致从60%关键帧到90%关键帧时动画回到元素原位置
    // 因此需要在90%关键帧处重新设置translateY的值，以便保证动画的正确效果
    const [{ duration: lastStillDur }] = translateYValue;
    const NINETY_KEYFRAME_RATE = 0.75;
    return [
        ...yTemp,
        {
            ...translateYValue[0],
            duration: NINETY_KEYFRAME_RATE * lastStillDur,
        },
        {
            ...translateYValue[0],
            duration: (1 - NINETY_KEYFRAME_RATE) * lastStillDur,
        },
    ];
};
// 中心旋转
export const getCenterResolveToStyle = (timeNode, playMode, animClass = presetClassTypes.ENTR) => {
    const animType = getAnimTypeByPlayMode(timeNode, playMode);
    if (animType !== AnimType.EntrCenterRevolve && animType !== AnimType.ExitCenterRevolve) return {};
    const { slideWidth, slideHeight } = getSlideWidthAndHeight(timeNode, playMode);
    const objRotate = getTnRotate(timeNode);
    const duration = getAnimDuration(timeNode, playMode);
    const INIT_TRANS_TIME_RATE = 0.4;
    const initTransDur = INIT_TRANS_TIME_RATE * duration;
    const OPACITY_TIME_RATE = 0.1;
    const showDur = OPACITY_TIME_RATE * duration;
    const xFrame = getTranslateKeyFrame(xTavlst, { attrName: 'ppt_x', attrValue: slideWidth, duration });
    const yFrame = getTranslateKeyFrame(yTavlst, { attrName: 'ppt_y', attrValue: slideHeight, duration });
    const translateXValue = [
        {
            value: 0,
            duration: showDur,
            easing: 'linear',
        },
        {
            value: 0,
            duration: initTransDur - showDur,
            easing: 'linear',
        },
    ];
    const translateYValue = [
        {
            value: ENTRY_REVOLVE_INIT_Y_RATE * slideHeight,
            duration: showDur,
            easing: 'linear',
        },
        {
            value: ENTRY_REVOLVE_INIT_Y_RATE * slideHeight,
            duration: initTransDur - showDur,
            easing: 'linear',
        },
    ];
    const opacity = getOpacityValueForCanvas(duration, playMode, animClass, xFrame);
    const translateX = getTranslateXForCanvas(xFrame, animClass, translateXValue);
    const translateY = getTranslateYForCanvas(yFrame, animClass, translateYValue, playMode);
    opacity.forEach((item, index) => {
        item.duration = translateX[index].duration;
    });
    return {
        opacity,
        translateX,
        translateY,
        scaleX: 1,
        scaleY: 1,
        rotate: objRotate,
    };
};
